export const SPOTLIGHT_SEARCH_SUPPORTED_MODULES = [
	'/media', // Asset bank
	'/account/dashboard', // Homepage/dashboard
	'/account/default', // Homepage/dashboard alternative path
	'/account/management/', // Account management - Bynder internal page
	'/account/smartfilters/', // Smart filters management page
	'/collections/', // Includes collections overview and collection detail view accessible at collection/view
	'/share/', // Shared collection
	'/web/', // Web/public collection
	'/show/', // PIM view for a specific metaproperty (e.g. /show/countries)
	'/guidelines/', // Guidelines pages including /guidelines/homepages and /guidelines/guide/:id
	'/styleguide/', // Old guidelines pages
	'/waitingroom/', // Waiting room
	'/workflow/', // Workflow module
	'/news/', // News module including pages like /news/management and /news/edit
	'/tags/management/', // Tags management page
	'/b-analytics/', // Analytics module
	'/profiles/management', // User profiles management page
	'/group/management', // Groups management pages
	'/content/notfound', // 404 page where Spotlight search bar is available
] as const;
